import type { FormKind } from '../api/catalog';
import { COPY } from '../copy';

export function kindLabel(kind: FormKind): string {
  return kind === 'XDP' ? COPY.kindPdf : COPY.kindAdaptive;
}

export function renditionLabel(rendition: string): string {
  switch (rendition) {
    case 'PRINT':
      return COPY.renditionPrint;
    case 'INTERACTIVE':
      return COPY.renditionInteractive;
    case 'DYNAMIC':
      return COPY.renditionDynamic;
    default:
      return rendition;
  }
}
